import { useEffect, useState } from "react";
import { Row, Col, Button, Card } from "reactstrap";
import ReactSelect, { components, createFilter } from "react-select";
import { Tooltip } from "@mui/material";
import { Theme, selectStyles } from "../../../../config/constants";
import { GiCutDiamond } from "react-icons/gi";
import { IoMdInformationCircle } from "react-icons/io";
import { BsCaretDownFill } from "react-icons/bs";
import { FaCircleMinus, FaCirclePlus, FaPlus, FaMedal, FaCopy } from "react-icons/fa6";
import itemScoreApi from "../../../../api/itemScoreApi";
import formatters from "../../../../config/formatters";
import ItemScoreComparisonChart from "./ItemScoreCharts/ItemScoreComparisonChart";
import { FaSquare } from "react-icons/fa";
import { toast } from "react-toastify";

const ItemScoreComparisonView = (props) => {
    const { numberFormatter } = formatters();
    const selectedCategory = props.selectedCategory;
    const selectedProduct = props.selectedProduct;
    const [selectedProductSwitches, setSelectedProductSwitches] = useState(null);
    const [selectedProductTrends, setSelectedProductTrends] = useState(null);
    const [numberOfCompetitors, setNumberofCompetitors] = useState(1);
    const [marketingInsightData, setMarketingInsightData] = useState(null);
    const [insightTextElement, setInsightTextElement] = useState([]);
    const [copyInsightText, setCopyInsightText] = useState('');
    const [selectedTimespan, setSelectedTimespan] = useState({value: 3, label: '3 Months'});
    const trendsTimeOptions = [
        {value: 3, label: '3 Months'},
        {value: 6, label: '6 Months'},
        {value: 12, label: '12 Months'},
        {value: 18, label: '18 Months'}
    ];

    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
            <BsCaretDownFill />
            </components.DropdownIndicator>
        );
    };

    const InputOption = ({
        getStyles,
        Icon,
        isDisabled,
        isFocused,
        isSelected,
        children,
        innerProps,
        ...rest
        }) => {
        const [isActive, setIsActive] = useState(false);
        const onMouseDown = () => setIsActive(true);
        const onMouseUp = () => setIsActive(false);
        const onMouseLeave = () => setIsActive(false);

        // styles
        let bg = "transparent";
        let textColor = "inherit";
        if (isDisabled) 
            { 
                bg = "rgb(230, 230, 230)";
                textColor= "rgb(77, 77, 77)";
            }
        if (isFocused && !isDisabled) bg = Theme().colors.accentLight;
        if (isActive) bg = Theme().colors.accent;

        const style = {
            alignItems: "center",
            backgroundColor: bg,
            color: textColor,
            display: "flex "
        };

        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown,
            onMouseUp,
            onMouseLeave,
            style
        };
        return (
            <components.Option
                {...rest}
                isDisabled={isDisabled}
                isFocused={isFocused}
                isSelected={isSelected}
                getStyles={getStyles}
                innerProps={props}
            >
                {children}
            </components.Option>
        );
    };

    const getComparisonProducts = () => {
        const params = {
            productId: selectedProduct.value,
            categoryId: selectedCategory.value
        };
        itemScoreApi.getCompProducts.post(params).then(response => {
            if(response.status === 200) {
                setSelectedProductSwitches(response.data.switches);
                setSelectedProductTrends(response.data.trends);
            }
        }).catch(err => {
            console.log(err);
            setSelectedProductSwitches(null);
            setSelectedProductTrends(null);
        })
    };

    const getMarketingProduct = () => {
        const params = {
            productId: selectedProduct.value
        };
        itemScoreApi.getMarketingProduct.get(params).then(response => {
            setMarketingInsightData(response.data);
        }).catch(err => {
            console.log(err);
        })
    };

    const updateInsightTextElement = () => {
        var insightText = null;
        var copyInsightText = null;
        if(marketingInsightData) {
            insightText = (
                <Col className="mb-4" style={{justifyItems: 'center'}}>
                    <Row style={{fontSize: '18px', marginBottom: '12px', justifyContent: 'center'}}>
                        <span className='w-fc px-0'>"We recommend you market&nbsp;</span>
                        <span className='w-fc px-0' style={{color: '#314175', fontWeight: '700', textTransform: 'capitalize'}}>{marketingInsightData.brand}&nbsp;{marketingInsightData.description.toLowerCase()}&nbsp;</span>
                        <span className='w-fc px-0'>to&nbsp;</span>
                        <span className='w-fc px-0' style={{color: '#314175', fontWeight: '700'}}>{marketingInsightData.cluster_name}</span>
                        <span className='w-fc px-0'>."</span>
                    </Row>
                    <Row style={{fontSize: '12px', justifyContent: 'center'}}>
                        <span className='w-fc px-0'>{marketingInsightData.cluster_name} are&nbsp;</span>
                        <span className='w-fc px-0' style={{color: '#314175', fontWeight: '700'}}>{marketingInsightData.insight}% MORE LIKELY&nbsp;</span>
                        <span className='w-fc px-0'>to switch from matching competitors to your&nbsp;</span>
                        <span className='w-fc px-0' style={{color: '#314175', fontWeight: '700', textTransform: 'capitalize'}}>{marketingInsightData.brand}&nbsp;{marketingInsightData.description.toLowerCase()}</span>
                        <span className='w-fc px-0'>.</span>
                    </Row>
                </Col>
            );
            copyInsightText = `We recommend you market ${marketingInsightData.brand} ${marketingInsightData.description} to ${marketingInsightData.cluster_name}. ${marketingInsightData.cluster_name} are ${marketingInsightData.insight}% MORE LIKELY to switch from matching competitors to your ${marketingInsightData.brand} ${marketingInsightData.description}.`;
        } else {
            insightText = (
                <Col className="mb-4" style={{justifyItems: 'center'}}>
                    <span style={{fontSize: '20px'}}>There is currently no Marketing Recommendation for this product. Check back again later.</span>
                </Col>
            );
            copyInsightText = '';
        }
        setCopyInsightText(copyInsightText);
        setInsightTextElement(insightText);
    }

    const copyRecommendation = () => {
        navigator.clipboard.writeText(copyInsightText);
        toast.success('Copied recommendation!')
    };

    useEffect(() => {
        if(selectedProduct) {
            getComparisonProducts();
            getMarketingProduct();
        }
    // eslint-disable-next-line
    }, [selectedProduct]);

    useEffect(() => {
        updateInsightTextElement();
    // eslint-disable-next-line
    }, [marketingInsightData])

    return (
        <Col className="my-2">
            <Card className="p-3">
                <Row className="mx-0" style={{height: '392px', gap: '1px', padding: '1px', background: '#D7D8D9', borderBottom: 'solid 1px lightgray'}}>
                    <Col style={{width: '20%', minWidth: '210px'}}>
                        <Row style={{height: '159px', background: '#F8F8F8', marginBottom: '1px'}}>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                        <Row style={{height: '74px', background: '#F8F8F8', marginBottom: '1px'}}>
                            <Col className="pt-3">
                                <div style={{fontSize: '16px', fontWeight: '600', display: 'flex'}}>
                                    <Tooltip title={"Example tooltip"} placement="top">
                                        <div className="w-fc">
                                            <IoMdInformationCircle color="#CF3F7C" style={{fontSize: "18px", position: 'relative', bottom: '2px'}} />
                                        </div>
                                    </Tooltip>
                                    <div style={{color: '#76777B'}}>SWITCHES</div>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', color: '#76777B', background: '#F8F8F8', marginBottom: '1px'}}>
                            <Col className="pt-3">
                            <div style={{fontSize: '16px', fontWeight: '600', display: 'flex'}}>
                                    <Tooltip title={"Example tooltip"} placement="top">
                                        <div className="w-fc">
                                            <IoMdInformationCircle color="#CF3F7C" style={{fontSize: "18px", position: 'relative', bottom: '2px'}} />
                                        </div>
                                    </Tooltip>
                                    <div style={{color: '#76777B'}}>PACK SIZES</div>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', color: '#76777B', background: '#F8F8F8', marginBottom: '1px'}}>
                            <Col className="pt-3">
                                <div style={{fontSize: '16px', fontWeight: '600', display: 'flex'}}>
                                    <Tooltip title={"Example tooltip"} placement="top">
                                        <div className="w-fc">
                                            <IoMdInformationCircle color="#CF3F7C" style={{fontSize: "18px", position: 'relative', bottom: '2px'}} />
                                        </div>
                                    </Tooltip>
                                    <div style={{color: '#76777B'}}># DAYS PURCHASED</div>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', color: '#76777B', background: '#F8F8F8', marginBottom: '1px'}}>
                            <Col className="pt-3">
                                <div style={{fontSize: '16px', fontWeight: '600', display: 'flex'}}>
                                    <Tooltip title={"Example tooltip"} placement="top">
                                        <div className="w-fc">
                                            <IoMdInformationCircle color="#CF3F7C" style={{fontSize: "18px", position: 'relative', bottom: '2px'}} />
                                        </div>
                                    </Tooltip>
                                    <div style={{color: '#76777B'}}># INVOICES</div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{width: '20%', minWidth: '215px'}}>
                        <Row style={{height: '159px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center'}}>
                            <Col>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>YOU</div>
                                    </Col>
                                </Row>
                                <Row className='mb-1' style={{textTransform: 'capitalize'}}>
                                <div style={{fontWeight: '500', fontSize: '18px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'capitalize'}} title={selectedProduct?.label ?? 'N/A'}>{selectedProduct?.label?.toLowerCase() ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: '#00A0FF', textAlign: 'center'}}>{selectedProductSwitches?.[0]?.item_score ?? 'N/A'}<GiCutDiamond size={'22px'} style={{position: 'relative', bottom: '3px'}}/></div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px', textAlign: 'center'}}>ITEM SCORE</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '74px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[0]?.switch_data?.[0]?.direction === 'to_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[0]?.switch_data?.[0]?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[0]?.direction === 'to_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[0]?.direction === 'from_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '600', fontSize: '12px'}}>{(numberOfCompetitors === 1) ? 'COMPETITOR 1' : 'COMP 1'}</div>
                                    </Col>
                                </Row>
                            </Col>
                            {(numberOfCompetitors >= 2) &&
                            <Col style={{borderLeft: '1px solid lightgray'}}>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[0]?.switch_data?.[1]?.direction === 'to_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[0]?.switch_data?.[1]?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[1]?.direction === 'to_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[1]?.direction === 'from_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '600', fontSize: '12px'}}>COMP 2</div>
                                    </Col>
                                </Row>
                            </Col>
                            }
                            {(numberOfCompetitors === 3) &&
                            <Col style={{borderLeft: '1px solid lightgray'}}>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[0]?.switch_data?.[2]?.direction === 'to_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[0]?.switch_data?.[2]?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[2]?.direction === 'to_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[0]?.switch_data?.[2]?.direction === 'from_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '600', fontSize: '12px'}}>COMP 3</div>
                                    </Col>
                                </Row>
                            </Col>
                            }
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[0]?.pack_size ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[0]?.days_purchased ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{(selectedProductSwitches?.length >= 1) ? numberFormatter.format(selectedProductSwitches?.[0]?.total_invoices) : 'N/A'}</div>
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{width: '20%', minWidth: '200px'}}>
                        <Row style={{height: '159px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center'}}>
                            <Col>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>COMPETITOR 1</div>
                                    </Col>
                                </Row>
                                <Row className="py-1" style={{textTransform: 'capitalize'}}>
                                    <div style={{fontWeight: '500', fontSize: '18px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'capitalize'}} title={selectedProductSwitches?.[1]?.description ?? 'N/A'}>{selectedProductSwitches?.[1]?.description?.toLowerCase() ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>{selectedProductSwitches?.[1]?.item_score ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px', textAlign: 'center'}}>ITEM SCORE</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '74px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[1]?.switch_data?.direction === 'from_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[1]?.switch_data?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[1]?.switch_data?.direction === 'from_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[1]?.switch_data?.direction === 'to_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px'}}>{(selectedProductSwitches?.[1]?.switch_data?.direction === 'from_product') ? 'FROM YOUR ITEM' : 'TO YOUR ITEM'}</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[1]?.pack_size ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[1]?.days_purchased ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{(selectedProductSwitches?.length >= 2) ? numberFormatter.format(selectedProductSwitches?.[1]?.total_invoices) : 'N/A'}</div>
                            </Col>
                        </Row>
                    </Col>
                    {(numberOfCompetitors >= 2) &&
                    <Col style={{width: '20%', minWidth: '200px'}}>
                        <Row style={{height: '159px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center'}}>
                            <Col>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>COMPETITOR 2</div>
                                    </Col>
                                </Row>
                                <Row className="my-1" style={{textTransform: 'capitalize'}}>
                                    <div style={{fontWeight: '500', fontSize: '18px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'capitalize'}} title={selectedProductSwitches?.[1]?.description ?? 'N/A'}>{selectedProductSwitches?.[2]?.description?.toLowerCase() ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>{selectedProductSwitches?.[2]?.item_score ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px', textAlign: 'center'}}>ITEM SCORE</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '74px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[2]?.switch_data?.direction === 'from_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[2]?.switch_data?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[2]?.switch_data?.direction === 'from_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[2]?.switch_data?.direction === 'to_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px'}}>{(selectedProductSwitches?.[2]?.switch_data?.direction === 'from_product') ? 'FROM YOUR ITEM' : 'TO YOUR ITEM'}</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[2]?.pack_size ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[2]?.days_purchased ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{(selectedProductSwitches?.length >= 3) ? numberFormatter.format(selectedProductSwitches?.[2]?.total_invoices) : 'N/A'}</div>
                            </Col>
                        </Row>
                    </Col>
                    }
                    {(numberOfCompetitors === 3) &&
                    <Col style={{width: '20%', minWidth: '200px'}}>
                        <Row style={{height: '159px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center'}}>
                            <Col>
                                <Row>
                                    <Col>
                                        <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>COMPETITOR 3</div>
                                    </Col>
                                </Row>
                                <Row className="my-1" style={{textTransform: 'capitalize'}}>
                                    <div style={{fontWeight: '500', fontSize: '18px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'capitalize'}} title={selectedProductSwitches?.[1]?.description ?? 'N/A'}>{selectedProductSwitches?.[3]?.description?.toLowerCase() ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', textAlign: 'center'}}>{selectedProductSwitches?.[3]?.item_score ?? 'N/A'}</div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px', textAlign: 'center'}}>ITEM SCORE</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '74px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <Row>
                                    <div style={{fontWeight: '700', fontSize: '20px', color: (selectedProductSwitches?.[3]?.switch_data?.direction === 'from_competitor') ? '#FF494D' : '#00A86B'}}>
                                        {selectedProductSwitches?.[3]?.switch_data?.n_switches ?? 'N/A'}
                                        {(selectedProductSwitches?.[3]?.switch_data?.direction === 'from_competitor') && <FaCircleMinus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                        {(selectedProductSwitches?.[3]?.switch_data?.direction === 'to_competitor') && <FaCirclePlus size={'17px'} style={{position: 'relative', bottom: '3px'}}/>}
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{fontWeight: '600', fontSize: '12px'}}>{(selectedProductSwitches?.[3]?.switch_data?.direction === 'from_product') ? 'FROM YOUR ITEM' : 'TO YOUR ITEM'}</div>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[3]?.pack_size ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{selectedProductSwitches?.[3]?.days_purchased ?? 'N/A'}</div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div style={{fontWeight: '600', fontSize: '16px'}}>{(selectedProductSwitches?.length >= 4) ? numberFormatter.format(selectedProductSwitches?.[3]?.total_invoices) : 'N/A'}</div>
                            </Col>
                        </Row>
                    </Col>
                    }
                    {(numberOfCompetitors < 3 && numberOfCompetitors < (selectedProductSwitches?.length -1)) &&
                    <Col style={{width: '20%'}}>
                        <Row style={{height: '159px', background: '#FFFFFF', marginBottom: '1px', alignContent: 'center', textAlign: 'center'}}>
                            <Col style={{justifyItems: 'center'}}>
                                <div style={{width: '156px'}}>
                                    <Button 
                                        block 
                                        className='py-2 button-label' 
                                        style={{color: 'white'}}
                                        size='sm' 
                                        onClick={() => {setNumberofCompetitors(numberOfCompetitors + 1)}} 
                                        color={'blueFilter'}><FaPlus size={'14px'} style={{position: 'relative', bottom: '1px'}}/> Add Competitor
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{height: '75px', background: '#FFFFFF', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                        <Row style={{height: '52px', background: '#FFFFFF', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                        <Row style={{height: '52px', background: '#FFFFFF', alignContent: 'center', textAlign: 'center'}}>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                        <Row style={{height: '51px', background: '#FFFFFF', alignContent: 'center', textAlign: 'center', marginBottom: '1px'}}>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                    </Col>
                    }
                </Row>
            </Card>
            <Card>
                <Row className='my-3'>
                    <Col className='w-100 p-2'>
                        <Row>
                            <Col className='w-fc mx-auto'>
                                <svg width="0" height="0">
                                <linearGradient id="medalGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop stopColor="#01A6CC" offset="0%" />
                                    <stop stopColor="#0F1740" offset="100%" />
                                </linearGradient>
                                </svg>
                                <FaMedal className='me-1' size={'24px'} style={{fill: 'url(#medalGradient)', bottom: '4px', position: 'relative'}}/>
                                <span style={{fontSize: '24px', fontWeight: '700', color: '#314175'}}>Marketing Recommendation</span>
                            </Col>
                        </Row>
                        <Row className='w-fc mx-auto h-100' style={{alignContent: 'center'}}>
                            <Col>
                                <Row>
                                    <div>
                                        {insightTextElement}
                                    </div>
                                </Row>
                                {marketingInsightData?.length >= 1 &&
                                <Row className='mt-2 mb-4' style={{justifyContent: 'center'}}>
                                    <Button     
                                        className='py-0 button-label px-3 py-1' 
                                        style={{width: '200px', color: 'white'}}
                                        size='sm' 
                                        color={'blueFilter'}
                                        onClick={() => copyRecommendation()}>
                                        <FaCopy/> Copy Recommendation
                                    </Button>
                                </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
            <Card className="px-3 pb-3">
                <Row className="mt-2">
                    <Col>
                        <Row>
                            <Col>
                                <div style={{fontWeight: '700', fontSize: '24px'}}>Item Score Trends</div>
                            </Col>
                        </Row>
                        <Row className="pb-2">
                            <Col>
                                <Row>
                                    <Col>
                                        <div style={{fontSize: '14px'}}>Select Time Range</div>
                                    </Col>
                                </Row>
                                <Row style={{width: '220px'}}>
                                    <Col>
                                        <ReactSelect 
                                            styles={selectStyles}
                                            components={{ DropdownIndicator, Option: InputOption}}
                                            captureMenuScroll={false}
                                            classNamePrefix="custom-select "
                                            filterOption={createFilter({ ignoreAccents: false })} 
                                            hideSelectedOptions={false}
                                            name='product' 
                                            options = {trendsTimeOptions}
                                            onChange = {(e) => setSelectedTimespan(e)}
                                            value = {selectedTimespan}
                                            placeholder='Select Timespan'
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <ItemScoreComparisonChart numberOfMonths={selectedTimespan?.value} chartData={selectedProductTrends?.slice(0, numberOfCompetitors + 1)} />
                            <Col className="col-3" style={{lineHeight: '1', alignContent: 'center'}}>
                                <Row className="mb-2">
                                    <Col>
                                        <Row>
                                            <Col className="w-fc pe-1 ps-0">
                                                <FaSquare color="#0F1740" style={{position: 'relative', bottom: '2px'}} />
                                            </Col>
                                            <Col className="w-fc pe-1 ps-0">
                                                <span style={{fontWeight: '700'}}>You</span>
                                            </Col>
                                            <Col className="w-fc px-0 ps-0">
                                                <span style={{fontWeight: '700', fontSize: '14px'}}>({selectedProductTrends?.[0]?.brand ?? 'N/A'})</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span style={{textTransform: 'capitalize', fontSize: '14px', color: 'darkgray'}}>{selectedProductTrends?.[0]?.description.toLowerCase() ?? 'N/A'}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col>
                                        <Row>
                                            <Col className="w-fc pe-1 ps-0">
                                                <FaSquare color="#00A86B" style={{position: 'relative', bottom: '2px'}} />
                                            </Col>
                                            <Col className="w-fc pe-1 ps-0">
                                                <span style={{fontWeight: '700'}}>Competitor 1</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span style={{textTransform: 'capitalize', fontSize: '14px', color: 'darkgray'}}>{selectedProductTrends?.[1]?.description.toLowerCase() ?? 'N/A'}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                {(numberOfCompetitors >= 2) && 
                                <Row className="mb-2">
                                    <Col>
                                        <Row>
                                            <Col className="w-fc pe-1 ps-0">
                                                <FaSquare color="#00A0FF" style={{position: 'relative', bottom: '2px'}} />
                                            </Col>
                                            <Col className="w-fc pe-1 ps-0">
                                                <span style={{fontWeight: '700'}}>Competitor 2</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span style={{textTransform: 'capitalize', fontSize: '14px', color: 'darkgray'}}>{selectedProductTrends?.[2]?.description.toLowerCase() ?? 'N/A'}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                }
                                {(numberOfCompetitors === 3) && 
                                <Row className="mb-2">
                                    <Col>
                                        <Row>
                                            <Col className="w-fc pe-1 ps-0">
                                                <FaSquare color="#CF3F7C" style={{position: 'relative', bottom: '2px'}} />
                                            </Col>
                                            <Col className="w-fc pe-1 ps-0">
                                                <span style={{fontWeight: '700'}}>Competitor 3</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span style={{textTransform: 'capitalize', fontSize: '14px', color: 'darkgray'}}>{selectedProductTrends?.[3]?.description.toLowerCase() ?? 'N/A'}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </Col>
    )
}

export default ItemScoreComparisonView;